module.exports = __webpack_public_path__ + "img/i_h2_function.e9a22ce6.svg";